export const PATTERN_NAME = "[a-zA-Zа-яА-ЯёЁ -]{2,30}";
export const PATTERN_EMAIL= '^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\\.)+[A-Za-z]+$';

export const MAIN_API = 'https://milenium666-mesto.online/api';
//export const MAIN_API = 'http://localhost:3000/api'

export const MOVIE_API = 'https://api.nomoreparties.co'

